if (!customElements.get('concours-countdown')) {
  class ConcoursCountdown extends HTMLElement {
    connectedCallback() {
      this.endDate = this.getAttribute('data-date');
      this.endTime = this.getAttribute('data-time');
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.mainEl = this.querySelector('.concours-countdown__main');
      this.endEl = this.querySelector('.concours-countdown__end');

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const target = new Date(`${this.endDate}T${this.endTime}`);
      const now = new Date();
      const distance = target - now;

      if (distance <= 0) {
        clearInterval(this.interval);
        if (this.mainEl) this.mainEl.style.display = 'none';
        if (this.endEl) this.endEl.style.display = 'flex';
        return;
      }

      const pad = (n) => String(Math.floor(n)).padStart(2, '0');

      if (this.daysEl) this.daysEl.textContent = pad(distance / 86400000);
      if (this.hoursEl) this.hoursEl.textContent = pad((distance % 86400000) / 3600000);
      if (this.minutesEl) this.minutesEl.textContent = pad((distance % 3600000) / 60000);
      if (this.secondsEl) this.secondsEl.textContent = pad((distance % 60000) / 1000);
    }
  }

  customElements.define('concours-countdown', ConcoursCountdown);
}
